import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CheckboxGridRow } from '../checkbox-grid.model';
import { CheckboxGridService } from './../checkbox-grid.service';

@Component({
  selector: 'checkbox-row',
  templateUrl: './checkbox-row.component.html',
  styleUrls: ['./checkbox-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxRowComponent implements OnInit, OnChanges {
  @Input() row: CheckboxGridRow;
  @Input() options: any;

  @Input() isReadOnly: boolean;

  @Output() rowUpdated: EventEmitter<CheckboxGridRow> =
    new EventEmitter<CheckboxGridRow>();

  ownRow;

  constructor(private checkboxGridService: CheckboxGridService) {}
  // populate map of row observables
  // in header subscribe to row map and transform data to be header -> [{checkbox}]
  // turn to all true or false
  // if bulk check, update row data through header.
  ngOnInit() {
    // this.row = this.checkboxGridService.rows.subscribe()
  }

  ngOnChanges(sc: SimpleChanges) {
    this.ownRow = this.row;
  }

  handleItemChecked(event) {
    this.rowUpdated.emit(this.row);
  }
}
